// extracted by mini-css-extract-plugin
export default {"background-$(backgroundColorBg)":"a1SMr","background-$(backgroundColor)":"b1SMr","autocomplete":"c1SMr","bottom":"d1SMr","top":"e1SMr","option":"f1SMr"};